import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthSessionStore } from '@indutrust/auth-data';
import { RouterStore } from '@indutrust/shared-data';
import {
  GlobalLoaderComponent,
  LayoutComponent,
} from '@indutrust/shared-feature';
import { Toast } from 'primeng/toast';
import { AppStore } from './+state/app.store';

@Component({
  selector: 'app-root',
  imports: [GlobalLoaderComponent, LayoutComponent, Toast],
  template: `
    <p-toast />
    @if (!appStore.isAppInitialized()) {
      <idt-global-loader />
    } @else {
      <idt-layout />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/**
 * Root application component managing app initialization and global notifications.
 *
 * This component is responsible for:
 * - Initializing the application (via AppStore)
 * - Displaying global loader during initialization
 * - Rendering the main layout via {@link Layout}
 *
 * Layout logic has been extracted to {@link Layout} for better separation of concerns.
 *
 * @example
 * <app-root></app-root>
 */
export class AppComponent {
  protected readonly appStore = inject(AppStore);
  protected readonly authSessionStore = inject(AuthSessionStore);
  protected readonly routerStore = inject(RouterStore);
}
